import { useCallback, useMemo, useState } from 'react';

import { AuthDialog } from './AuthDialog';
import { AuthDialogContext } from './authDialogContext';

const CLOSED = { isOpen: false, mode: 'login', afterSignupPath: undefined, expired: false };

/**
 * The public pages' sign-in window, rendered once: the nav, the landing's buttons, /login and the signup ads' link
 * all open this same window (useAuthDialog), which switches between sign in, sign up and password recovery in place.
 */
export const AuthDialogProvider = ({ children }) => {
  const [state, setState] = useState(CLOSED);

  // afterSignupPath: where a new account lands (the signup ads' link sends it to /workout).
  // expired: a session that ran out (/login/<page>): the window says so and follows the app's theme.
  const openAuth = useCallback((mode = 'login', { afterSignupPath, expired = false } = {}) => {
    setState({ isOpen: true, mode, afterSignupPath, expired });
  }, []);
  const closeAuth = useCallback(() => setState((current) => ({ ...current, isOpen: false })), []);
  const setMode = useCallback((mode) => setState((current) => ({ ...current, mode })), []);

  const value = useMemo(() => ({ openAuth, closeAuth }), [openAuth, closeAuth]);

  return (
    <AuthDialogContext.Provider value={value}>
      {children}
      <AuthDialog {...state} onModeChange={setMode} onClose={closeAuth} />
    </AuthDialogContext.Provider>
  );
};
